module.exports = __webpack_public_path__ + "img/2.9326fb52.jpg";